export class InvestmentPropertyConst {
  public static headerTable = [
    { field: 'accountingModelsNumber', title: 'Cuenta contable', cell: (row) => row.accountingModelsNumber ? `${row.accountingModelsNumber}` : '', class: (row) => `` },
    { field: 'investmentDescription', title: 'Valor de la inversión', cell: (row) => row.investmentDescription ? `${row.investmentDescription}` : '', class: (row) => `` },
    {
      field: 'companyPremisesOrOffice', title: 'Local/Oficina empresa', cell: (row) =>
      row.companyPremisesOrOffice === true ? 'Si' : 'No', class: (row) => ``
    },
    {
      field: 'paided', title: 'Pagado', cell: (row) =>
        row.paided ? `${row.paided}` : '0.00', class: (row) => ``
    }
  ];
}
